<script context="module">
	//there is a nl character & that is replaced differently depending on the need.
	//for console <br/>&gt;
	//for pick game it is removed
	//hidden messages from reading from ports
	//have broken ports
	export const NumberOfLevels = 20;
	
	export const LevelsID = {
	    '1': {ID: 1, 
	    Order: 1,
        Name: 'Port Identity', 
        Description:'Take in input from U and output it to D.',
        DBGinU:'11,2,15,14,5,23,4,19,9,10', 
        DBGoutD:'11,2,15,14,5,23,4,19,9,10',
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'',
        StarInst:1,
        StarCycles:21,
        StarPorts:20},
        //***********************************************************
         '2': {ID: 2, 
        Order: 2,
        Name: 'Stored Data', 
        Description:'Keep outputting the first number. &LEFT port not working.',
        DBGinU:'11,2,15,14,5,23,4,19,9,10', 
        DBGoutD:'11,11,11,11,11,11,11,11,11,11',
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'L',
        Hidden:'',
        StarInst:3,
        StarCycles:31,
        StarPorts:11},
        //***********************************************************
        '7':{ID: 7, 
        Order: 3,
        Name: 'Input Summation', 
        Description:'Add all the numbers. &RIGHT port not working.',
        DBGinU:'3,4,9,8,10,15,2,1,0,12', 
        DBGoutD:'3,7,16,24,34,49,51,52,52,64',
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'R',
        Hidden:'TEST',
        StarInst:2,
        StarCycles:31,
        StarPorts:20},
        
        //***********************************************************
        '4':{ID: 4, 
        Order: 4,
        Name: 'Alternating Operations', 
        Description:'Alternate adding and subtracting the input. &RIGHT port not working.',
        DBGinU:'7,21,5,9,19,41,38,6,7,21', 
        DBGoutD:'7,-14,-9,-18,1,-40,-2,-8,-1,-22',
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'R',
        Hidden:'RANDY',
        StarInst:4,
        StarCycles:31,
        StarPorts:20},
        //***********************************************************
        '14': {ID: 14, 
        Order: 5,
        Name: 'Signal Passing', 
        Description:'Take input from U and share it with the other ports.',
        DBGinU:'8,12,73,54,5,66,57,2,95,10', 
        DBGoutL:'8,12,73,54,5,66,57,2,95,10', 
        DBGoutD:'8,12,73,54,5,66,57,2,95,10', 
        DBGoutR:'8,12,73,54,5,66,57,2,95,10', 
        DBGsize:10,
        NumIn:1,
        NumOut:3,
        InPort:'U',
        OutPort:'LDR',
        BrokenPort:'',
        Hidden:'',
        StarInst:4,
        StarCycles:81,
        StarPorts:40},
        //***********************************************************
        '22': { ID: 22, 
        Order: 6,
        Name: 'Absolute Value', 
        Description:'Output the absolute value of the number. &LEFT, RIGHT ports not working.',
        DBGinU:'1,-2,-15,-14,5,23,-4,18,-9,10', 
        DBGoutD:'1,2,15,14,5,23,4,18,9,10', 
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'LR',
        Hidden:'CAN USE TIS ENTGLMNT',
        StarInst:4,
        StarCycles:56,
        StarPorts:20},
        //***********************************************************
        '3': {ID: 3, 
        Order: 7,
        Name: 'Port Scanning', 
        Description:'Take alternating input from three ports and output to one.',
        DBGinL:'1,-,-,-,5,-,-,-,9,-', 
        DBGinU:'-,2,-,4,-,6,-,8,-,10', 
        DBGinR:'-,-,3,-,-,-,7,-,-,-', 
        DBGoutD:'1,2,3,4,5,6,7,8,9,10',
        DBGsize:10,
        NumIn:3,
        NumOut:1,
        InPort:'LUR',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'',
        StarInst:4,
        StarCycles:21,
        StarPorts:20},
        //***********************************************************
        '5':{ID: 5, 
        Order: 8,
        Name: 'Subtraction', 
        Description:'Add input from left and subtract from right +L-R and output after each operation.',
        DBGinL:'4,0,5,4,2,0,19,3,0,12', 
        DBGinR:'2,8,9,0,0,7,6,11,3,6',
        DBGoutD:'2,-8,-4,4,2,-7,13,-8,-3,6',
        DBGsize:10,
        NumIn:2,
        NumOut:1,
        InPort:'LR',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'',
        StarInst:4,
        StarCycles:61,
        StarPorts:30},
        //***********************************************************
        '6': { ID: 6, 
        Order: 9,
        Name: 'Exponential Growth', 
        Description:'Output the powers of 2. &UP, LEFT ports not working.',
        DBGoutD:'1,2,4,8,16,32,64,128,256,512',
        DBGsize:10,
        NumIn:0,
        NumOut:1,
        InPort:'',
        OutPort:'D',
        BrokenPort:'UL',
        Hidden:'SPY COMMS',
        StarInst:4,
        StarCycles:40,
        StarPorts:10},
       
        //***********************************************************
        '8':{ID: 8, 
        Order: 10,
        Name: 'Add and Subtract', 
        Description:'Sum input from U and output to D, and Subtract input from L and output to R.',
        DBGinU:'4,0,5,4,2,0,19,-3,0,12', 
        DBGinL:'2,8,-9,0,0,7,6,11,3,-6',
        DBGoutD:'4,4,9,13,15,15,34,31,31,43',
        DBGoutR:'-2,-10,-1,-1,-1,-8,-14,-25,-28,-22',
        DBGsize:10,
        NumIn:2,
        NumOut:2,
        InPort:'UL',
        OutPort:'DR',
        BrokenPort:'',
        Hidden:'',
        StarInst:6,
        StarCycles:80,
        StarPorts:40},
        //***********************************************************
        '9': { ID: 9, 
        Order: 11,
        Name: 'Positives', 
        Description:'Output 1 if the number is greater than 0, 0 if equal, and -1 if less than 0. &RIGHT port not working.',
        DBGinU:'14,5,-13,24,0,16,-7,-1,0,20', 
        DBGoutD:'1,1,-1,1,0,1,-1,-1,0,1',
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'R',
        Hidden:'MAY BE TRACKED',
        StarInst:8,
        StarCycles:66,
        StarPorts:20},
        //***********************************************************
        '23': { ID: 23, 
        Order: 12,
        Name: 'Swapping Test', 
        Description:'Add inputs from U together and output to D while also adding inputs for L together and output to R.',
        DBGinU:'-1,-2,4,14,5,-3,4,6,9,-11', 
        DBGoutD:'-1,-3,1,15,20,17,21,27,36,25',
        DBGinL:'11,-2,-15,7,5,3,-4,8,-9,10', 
        DBGoutR:'11,9,-6,1,6,9,5,13,4,14',
        DBGsize:10,
        NumIn:2,
        NumOut:2,
        InPort:'UL',
        OutPort:'DR',
        BrokenPort:'',
        Hidden:'',
        StarInst:6,
        StarCycles:80,
        StarPorts:40},
        //***********************************************************
        '10':{ ID: 10, 
        Order: 13,
        Name: 'Fibonacci Sequence', 
        Description:'Output the first 10 numbers of the Fibonacci sequence.',
        DBGoutD:'0,1,1,2,3,5,8,13,21,34',
        DBGsize:10,
        NumIn:0,
        NumOut:1,
        InPort:'',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'',
        StarInst:12,
        StarCycles:105,
        StarPorts:60},
          //***********************************************************
        '21': { ID: 21, 
        Order: 14,
        Name: 'Modular Arithmetic', 
        Description:'Convert the hour from military time to standard time. &LEFT port not working.',
        DBGinU:'2,18,23,7,13,21,16,0,11,12', 
        DBGoutD:'2,6,11,7,1,9,4,12,11,12', 
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'L',
        Hidden:'DORIS I LOVE YOU',
        StarInst:12,
        StarCycles:98,
        StarPorts:20},
         //***********************************************************
        '20': { ID: 20, 
        Order: 15,
        Name: 'Signal Comparator', 
        Description:'Compare signals from Left and Right and output 1 if they are the same, and 0 if they are not. &DOWN port not working.',
        DBGinL:'12,1,7,3,4,5,2,0,8,29', 
        DBGinR:'4,1,7,10,4,6,16,22,8,29', 
        DBGoutU:'0,1,1,0,1,0,0,0,1,1', 
        DBGsize:10,
        NumIn:2,
        NumOut:1,
        InPort:'LR',
        OutPort:'U',
        BrokenPort:'D',
        Hidden:'USE IF THEY COME',
        StarInst:6,
        StarCycles:66,
        StarPorts:30},
        
        //***********************************************************
        '11': { ID: 11, 
        Order: 16,
		Name: 'Maximal Input', 
		Description:'Find the largest number by outputting the largest number seen so far. &LEFT port not working.',
		DBGinU:'1,2,15,14,5,23,4,18,9,10', 
		DBGoutD:'1,2,15,15,15,23,23,23,23,23',
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'L',
        Hidden:'WILL FIND OTHERS',
        StarInst:14,
        StarCycles:124,
        StarPorts:50},
        //***********************************************************
        '12': { ID: 12, 
        Order: 17,
		Name: 'Minimal Input', 
		Description:'Find the smallest number by outputting the smallest number seen so far.',
		DBGinU:'12,32,15,16,5,23,4,18,9,11', 
		DBGoutD:'12,12,12,12,5,5,4,4,4,4',
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'',
        StarInst:12,
        StarCycles:129,
        StarPorts:54},

        //***********************************************************
        '13': { ID: 13, 
        Order: 18,
        Name: 'Port Comparator', 
        Description:'Output the biggest number to D from the two input ports U and L.',
        DBGinU:'1,2,73,54,5,66,57,58,95,10', 
        DBGinL:'11,12,23,54,55,66,47,48,39,40', 
        DBGoutD:'11,12,73,54,55,66,57,58,95,40',
        DBGsize:10,
        NumIn:2,
        NumOut:1,
        InPort:'UL',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'',
        StarInst:11,
        StarCycles:110,
        StarPorts:44},
         //***********************************************************
        '15': { ID: 15, 
        Order: 19,
        Name: 'Parity Verification', 
        Description:'Take input from U and output 0 to L and R if the number is even and 1 to L and R if the number is odd. &DOWN port not working.',
        DBGinU:'8,12,13,24,5,16,37,3,25,10', 
        DBGoutL:'0,0,1,0,1,0,1,1,1,0', 
        DBGoutR:'0,0,1,0,1,0,1,1,1,0', 
        DBGsize:10,
        NumIn:1,
        NumOut:2,
        InPort:'U',
        OutPort:'LR',
        BrokenPort:'D',
        Hidden:'DONT TRUST GOVT',
        StarInst:10,
        StarCycles:366,
        StarPorts:30},
        
        //***********************************************************
        /*'16': { ID: 16, 
        Order: 20,
        Name: 'Squares', 
        Description:'Take in a number from U and output U^2 (U squared) to D.',
        DBGinU:'0,1,2,3,4,5,6,7,8,9', 
        DBGoutD:'0,1,4,9,16,25,36,49,64,81', 
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'',
        StarInst:13,
        StarCycles:366,
        StarPorts:30},*/
        //***********************************************************
        /*'17': { ID: 17, 
        Order: 20,
        Name: 'Largest Port Sum', 
        Description:'Take input from L and R and keep a separate total for each. At each step, output 1 if the L sum is greater, and 2 if the R sum is.',
        DBGinL:'8,12,13,4,5,16,4,8,1,8', 
        DBGinR:'3,1,15,22,15,1,7,3,5,10', 
        DBGoutD:'1,1,1,2,2,1,2,1,2,2', 
        DBGsize:10,
        NumIn:2,
        NumOut:1,
        InPort:'LR',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'',
        StarInst:1,
        StarCycles:1,
        StarPorts:1},*/
        //***********************************************************
        '25': { ID: 25, 
        Order: 20,
        Name: 'Multiplier', 
        Description:'Multiply each number by 7. &LEFT port not working.',
        DBGinU:'0,1,2,3,4,5,6,7,8,9', 
        DBGoutD:'0,7,14,21,28,35,42,49,56,63', 
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'L',
        Hidden:'NOW TURN OFF',
        StarInst:11,
        StarCycles:368,
        StarPorts:20},
       
        //***********************************************************
        /*'19': { ID: 19, 
        Order: 22,
        Name: 'Multiplication', 
        Description:'Compute L*R and output the answer to D.',
        DBGinR:'3,5,7,4,0,3,2,3,11,7', 
        DBGinL:'2,2,1,6,5,5,18,3,9,8', 
        DBGoutD:'6,10,7,24,0,15,36,9,99,56', 
        DBGsize:10,
        NumIn:2,
        NumOut:1,
        InPort:'LR',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'NOW TURN OFF',
        StarInst:13,
        StarCycles:366,
        StarPorts:30},*/
        //***********************************************************
        /*'18': { ID: 18, 
        Order: 23,
        Name: 'Integer Division', 
        Description:'Compute N/D given from port U and output the answer and remainder to R.',
        DBGinU:'6,3,13,7,15,4,37,3,12,25,9,2', 
        DBGoutR:'2,0,1,6,3,3,12,1,0,12,4,1', 
        DBGsize:12,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'R',
        BrokenPort:'',
        Hidden:'',
        StarInst:1,
        StarCycles:1,
        StarPorts:1},*/
         //***********************************************************
        /*'18': { ID: 18, 
        Order: 15,
        Name: 'Integer Division', 
        Description:'Compute U/D and output the answer to L and the remainder to R.',
        DBGinU:'6,12,13,27,5,16,37,3,2,25', 
        DBGinD:'3,5,7,4,1,3,2,3,5,9', 
        DBGoutL:'2,2,1,6,5,5,18,1,0,2', 
        DBGoutR:'0,2,6,3,0,1,1,0,2,7', 
        DBGsize:10,
        NumIn:2,
        NumOut:2,
        InPort:'UD',
        OutPort:'LR',
        BrokenPort:'',
        Hidden:'',
        StarInst:13,
        StarCycles:366,
        StarPorts:30},*/
        //***********************************************************
        /*'14': { id: 14, 
        Name: 'Stuck in the Middle', 
        Description:'Output the middle number from the 3 ports.',
        DBGinU:'1, 2, 23,54,5,69,57,58,95,100', 
        DBGinL:'11,12,73,54,55,66,47,48,39,40', 
        DBGinR:'16,42,53,43,5,67,74,83,93,30', 
        DBGoutD:'11,12,53,54,5,67,57,58,93,40',
        DBGsize:10,
        NumIn:3,
        NumOut:1,
        InPort:'ULR',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'',
        StarInst:1,
        StarCycles:20,
        StarPorts:20}*/
         //***********************************************************
        /*'10': { id: 10, 
        Name: 'Biggest Port 3', 
        Description:'Output the biggest number from the 3 ports.',
        DBGinU:'1,2,23,54,5,66,57,58,95,100', 
        DBGinL:'11,12,73,54,55,66,47,48,39,40', 
        DBGinR:'16,42,53,43,5,67,74,83,93,30', 
        DBGoutD:'16,42,73,54,55,67,74,83,95,100',
        DBGsize:10,
        NumIn:3,
        NumOut:1,
        InPort:'ULR',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'',
        StarInst:1,
        StarCycles:20,
        StarPorts:20},*/
        //***********************************************************
        /*'16': { ID: 16, 
        Order: 16,
        Name: 'Clock Rounds', 
        Description:'Output 15 number increments clockwise around the ports',
        DBGoutU:'0,60,120,180,240,300,360,420', 
        DBGoutR:'15,75,135,195,255,315,375,435', 
        DBGoutD:'30,90,150,210,270,330,390,450', 
        DBGoutL:'45,105,165,225,285,345,405,465', 
        DBGsize:8,
        NumIn:0,
        NumOut:4,
        InPort:'',
        OutPort:'URDL',
        BrokenPort:'',
        Hidden:'',
        StarInst:8,
        StarCycles:96,
        StarPorts:32},*/
          //***********************************************************
        /*'20': { ID: 20, 
        Order: 15,
        Name: 'Bit Shift', 
        Description:'Take in a number from U. If the output is > 100, output the hundreds digit, otherwise output the ones digit.',
        DBGinU:'14,81,221,121,47,655,336,66,8,29', 
        DBGoutD:'4,1,2,1,7,6,3,6,8,9', 
        DBGsize:10,
        NumIn:1,
        NumOut:1,
        InPort:'U',
        OutPort:'D',
        BrokenPort:'',
        Hidden:'',
        StarInst:1,
        StarCycles:1,
        StarPorts:1},*/
	};
	
	
</script>